import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </span>
              <span className="font-display font-bold text-lg text-background-50">在线视频</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              海量视频资源在线观看平台，汇聚电影、电视剧、综艺与短视频，让你随时随地发现想看的内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/category/${c.key}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  搜索视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                support@online-video.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                服务时间：每日 9:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 在线视频。本站内容为演示用途，播放功能为前端模拟，仅供学习参考。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-400">隐私政策</span>
            <span className="text-xs text-background-400">用户协议</span>
          </div>
        </div>
      </div>
    </footer>
  );
}